export default "__VITE_ASSET__C96E16V1__"